import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const PrintBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  p: { sm: '450' },
})`
  ${({ theme }) => css`
    width: 196px;
  `}
`;

export const QRCodeImageStyled = styled.img`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 0 0 ${theme.spacings[300]} ${theme.spacings[300]};
  `};
`;
export const DashedBorderStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    width: 100%;
    border: 1px dashed ${theme.colors.grey['600']};
  `}
`;
